var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadInclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L3 8V21H21Z",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 8C13.25 9.79493 11.7949 11.25 10 11.25C8.20507 11.25 6.75 9.79493 6.75 8C6.75 6.20507 8.20507 4.75 10 4.75C11.7949 4.75 13.25 6.20507 13.25 8Z",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8258 14.0507L14.601 11.7078C14.3617 11.5339 14.3086 11.1989 14.4825 10.9595C14.6564 10.7201 14.9914 10.6671 15.2308 10.841L18.4556 13.1839L19.1386 12.2438C19.3301 11.9802 19.7397 12.044 19.8419 12.3534L20.7669 15.1513C20.8528 15.411 20.6585 15.6783 20.3851 15.6769L17.4383 15.6618C17.1124 15.6601 16.9251 15.2903 17.1167 15.0267L17.8258 14.0507Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadInclined);
export default __webpack_public_path__ + "static/media/road-inclined.f364125a7a895a552b37ade3347133e0.svg";
export { ForwardRef as ReactComponent };